import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRing, AlertTriangle, CalendarClock, ChevronRight } from "lucide-react";
import api from "../lib/api";

const SEVERITY_CLS = {
  high: "bg-[#FCEAE8] border-[#B54D40]/25",
  medium: "bg-[#FDF3E1] border-[#C48231]/25",
};
const ICON_COLOR = { high: "text-[#B54D40]", medium: "text-[#C48231]" };

export const AlertsPanel = () => {
  const [alerts, setAlerts] = useState(null);

  useEffect(() => {
    api.get("/alerts").then((res) => setAlerts(res.data));
  }, []);

  if (!alerts || alerts.length === 0) return null;

  return (
    <section data-testid="alerts-panel" className="fade-in-up">
      <div className="flex items-center gap-2 mb-3">
        <BellRing className="w-5 h-5 text-[#C07A60]" strokeWidth={1.5} />
        <h2 className="text-lg font-heading font-semibold">Alerts</h2>
        <span data-testid="alerts-count" className="bg-[#C07A60] text-white text-xs font-bold rounded-full px-2 py-0.5">
          {alerts.length}
        </span>
      </div>
      <div className="space-y-2">
        {alerts.map((a, i) => {
          const Icon = a.kind.includes("expir") ? CalendarClock : AlertTriangle;
          const inner = (
            <div
              data-testid={`alert-row-${i}`}
              className={`flex items-start gap-3 border rounded-lg p-4 transition-all duration-200 ${SEVERITY_CLS[a.severity] || SEVERITY_CLS.medium} ${
                a.doc_id || a.caregiver_id || a.schedule_id || a.property_log_id ? "hover:-translate-y-0.5 hover:shadow-sm cursor-pointer" : ""
              }`}
            >
              <Icon className={`w-5 h-5 shrink-0 mt-0.5 ${ICON_COLOR[a.severity]}`} strokeWidth={1.5} />
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#1C211F]">{a.title}</p>
                <p className="text-sm text-[#57605A] mt-0.5">{a.detail}</p>
              </div>
              {(a.doc_id || a.caregiver_id || a.schedule_id || a.property_log_id) && (
                <ChevronRight className="w-4 h-4 text-[#57605A] shrink-0 mt-1" strokeWidth={1.5} />
              )}
            </div>
          );
          if (a.doc_id) return <Link key={i} to={`/documents/${a.doc_id}`}>{inner}</Link>;
          if (a.caregiver_id) return <Link key={i} to="/caregivers">{inner}</Link>;
          if (a.schedule_id) return <Link key={i} to="/schedule">{inner}</Link>;
          if (a.property_log_id) return <Link key={i} to="/property">{inner}</Link>;
          return <div key={i}>{inner}</div>;
        })}
      </div>
    </section>
  );
};
